import React, { useMemo } from "react";
import { VisuallyHiddenElement } from "shared/styles/constants";
import { ITheme } from "shared/types";

import { StyledButton, StyledButtonProps } from "./styles";
import { CSSProperties } from "styled-components";
import { Checkbox } from "../Form/Fields/Option/Checkbox";

export interface CheckboxButtonProps extends StyledButtonProps {
  id?: string;
  "data-testid"?: string;
  disabled?: boolean;
  type?: "submit" | "button";
  className?: string;
  value?: string;
  "aria-label"?: string;
  onClick?: () => void;
  style?: CSSProperties;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
}

export const CheckboxButton: React.FC<CheckboxButtonProps> = ({
  theme = ITheme.secondary,
  size = "m",
  type = "button",
  onClick,
  fakeHidden,
  disabled,
  style,
  checked,
  onChange,
  label,
  ...rest
}) => {
  const content = useMemo(
    () => (
      <StyledButton
        size={size}
        theme={theme}
        type={type}
        onClick={() => {
          if (onChange) {
            onChange({
              target: { checked: !checked },
            } as React.ChangeEvent<HTMLInputElement>);
          }
          if (onClick) onClick();
        }}
        fakeHidden={fakeHidden}
        tabIndex={fakeHidden ? -1 : 0}
        disabled={disabled}
        {...rest}
        style={{
          ...style,
          paddingRight: "11px",
        }}
      >
        {label && <span>{label}</span>}
        <Checkbox
          name="select"
          value="all"
          checked={checked}
          onChange={() => {}}
          tabIndex={-1}
          style={{ pointerEvents: "none" }}
          aria-hidden="true"
        />
      </StyledButton>
    ),
    [fakeHidden, onClick, disabled, rest, size, theme, type, style, checked, onChange, label]
  );

  if (fakeHidden) return <VisuallyHiddenElement>{content}</VisuallyHiddenElement>;

  return content;
};
